import { colors } from '../../colors';
var book = {
  fieldBorderColor: colors.equineIron,
  errorColor: colors.warningRed
};
export default book;